import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Row from 'component/utils/Row'
import Mask from 'vanilla-masker'
import LmExpressModal from 'component/report/lmexpress/LmExpressModal'
import { LMEXPRESS_TYPE } from 'constants/config'

class OlderLmExpress extends Component {
  constructor(props) {
    super(props)

    const { translate } = props

    this.state = {
      toogleModal: false,
      icon: '',
      titleText: '',
      value: 0,
      valueComplement: '',
      subtitle: '',
      titleList: '',
      listSections: [],
      typeContent: 0,
      currency: translate('option.currency'),
      sizeCurrency: translate('size.currency'),
      formatCurrency: {
        separator: translate('separator.currency'),
        delimiter: translate('delimiter.currency'),
      },
    }

    this.handleModal = this.handleModal.bind(this)
    this.renderModal = this.renderModal.bind(this)
    this.toogleModal = this.toogleModal.bind(this)
  }

  toogleModal() {
    this.setState({ toogleModal: !this.state.toogleModal })
  }

  handleModal(typeLmExpress) {
    const { translate, filters, lmExpress } = this.props

    const { toogleModal } = this.state

    if (toogleModal) {
      this.setState({ toogleModal: false })
    }

    let state = {
      valueComplement: '',
      toogleModal: true,
    }

    switch (typeLmExpress) {
      case LMEXPRESS_TYPE.CLIENTS:
        state = {
          ...state,
          titleText: translate('lmexpress.totalClientsTitle'),
          subText:
            filters.dtStart || filters.dtEnd
              ? `${filters.dtStart} - ${filters.dtEnd}`
              : '',
          value: lmExpress.totalClients,
          subtitle: translate('lmexpress.totalClientsText'),
          titleList: translate('lmexpress.clientsPerHour'),
          listSections: lmExpress.detailsClients,
          typeContent: LMEXPRESS_TYPE.CLIENTS,
        }
        break
      case LMEXPRESS_TYPE.LMS:
        state = {
          ...state,
          titleText: translate('lmexpress.totalLmsTitle'),
          subText:
            filters.dtStart || filters.dtEnd
              ? `${filters.dtStart} - ${filters.dtEnd}`
              : '',
          value: lmExpress.totalLm,
          subtitle: translate('lmexpress.totalLmsText'),
          titleList: translate('lmexpress.rankingLMs'),
          listSections: lmExpress.detailsProducts,
          typeContent: LMEXPRESS_TYPE.LMS,
        }
        break
      case LMEXPRESS_TYPE.SECTIONS:
        state = {
          ...state,
          titleText: translate('lmexpress.totalSectionsTitle'),
          subText:
            filters.dtStart || filters.dtEnd
              ? `${filters.dtStart} - ${filters.dtEnd}`
              : '',
          value: lmExpress.totalSections,
          subtitle: translate('lmexpress.totalSectionsText'),
          titleList: translate('lmexpress.itemsPerSection'),
          listSections: lmExpress.detailsSections,
          typeContent: LMEXPRESS_TYPE.SECTIONS,
        }
        break
      default:
        break
    }

    this.setState(state)
  }

  renderModal() {
    const { translate } = this.props

    const {
      toogleModal,
      titleText,
      subText,
      value,
      subtitle,
      titleList,
      listSections,
      typeContent,
    } = this.state

    if (!toogleModal) {
      return
    }

    const props = {
      translate,
      closeModal: this.toogleModal,
      titleText,
      subText,
      value,
      subtitle,
      titleList,
      listSections,
      typeContent,
    }

    return <LmExpressModal {...props} />
  }

  render() {
    const { translate, lmExpress, getCsv, filters } = this.props

    return (
      <div className='lmexpress-page container-mobile'>
        <div className='margin-left-double margin-right-double'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} sm={12} md={9}>
              <Row>
                <Col xs={12} sm={6} md={3}>
                  <div className='rectangle border rounded'>
                    <div className='circular wrap'>
                      <i className='clients' />
                    </div>

                    <div
                      className='circular wrap-click'
                      onClick={() => this.handleModal(LMEXPRESS_TYPE.CLIENTS)}
                    >
                      <i className='plus' />
                    </div>

                    <h4 className='heading-4 uppercase title'>
                      {translate('lmexpress.totalClientsTitle')}
                    </h4>
                    <div>
                      <span className='highlighted-number'>
                        {lmExpress.totalClients}
                      </span>
                      <span className='subtext'>
                        {filters.dtStart || filters.dtEnd
                          ? `${filters.dtStart} - ${filters.dtEnd}`
                          : ''}
                      </span>
                    </div>
                    <p className='text'>
                      {translate('lmexpress.totalClientsText')}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={6} md={3}>
                  <div className='rectangle border rounded'>
                    <div className='circular wrap'>
                      <i className='lm' />
                    </div>

                    <div
                      className='circular wrap-click'
                      onClick={() => this.handleModal(LMEXPRESS_TYPE.LMS)}
                    >
                      <i className='plus' />
                    </div>

                    <h4 className='heading-4 uppercase title'>
                      {translate('lmexpress.totalLmsTitle')}
                    </h4>
                    <div>
                      <span className='highlighted-number'>
                        {lmExpress.totalLm}
                      </span>
                      <span className='subtext'>
                        {filters.dtStart || filters.dtEnd
                          ? `${filters.dtStart} - ${filters.dtEnd}`
                          : ''}
                      </span>
                    </div>
                    <p className='text'>
                      {translate('lmexpress.totalLmsText')}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={6} md={3}>
                  <div className='rectangle border rounded'>
                    <div className='circular wrap'>
                      <i className='section' />
                    </div>

                    <div
                      className='circular wrap-click'
                      onClick={() => this.handleModal(LMEXPRESS_TYPE.SECTIONS)}
                    >
                      <i className='plus' />
                    </div>

                    <h4 className='heading-4 uppercase title'>
                      {translate('lmexpress.totalSectionsTitle')}
                    </h4>
                    <div>
                      <span className='highlighted-number'>
                        {lmExpress.totalSections}
                      </span>
                      <span className='subtext'>
                        {filters.dtStart || filters.dtEnd
                          ? `${filters.dtStart} - ${filters.dtEnd}`
                          : ''}
                      </span>
                    </div>
                    <p className='text'>
                      {translate('lmexpress.totalSectionsText')}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={6} md={3}>
                  <div className='rectangle border rounded'>
                    <div className='circular wrap'>
                      <i className='cart' />
                    </div>
                    <h4 className='heading-4 uppercase title'>
                      {translate('lmexpress.cartTitle')}
                    </h4>
                    <div>
                      <span className='highlighted-number'>
                        {lmExpress.avgCartItens}{' '}
                      </span>
                      <span className='subtext'>
                        {translate('lmexpress.items')}
                      </span>
                    </div>
                    <p className='text'>
                      {translate('option.currency')}{' '}
                      <span className='highlighted-number'>
                        {Mask.toMoney(
                          lmExpress.avgCartPrice
                            ? lmExpress.avgCartPrice.toFixed(
                                this.state.sizeCurrency
                              )
                            : 0,
                          this.state.formatCurrency
                        )}
                      </span>
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col xs={12} sm={12} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='dollar' />
                </div>
                <h4 className='heading-4 uppercase title'>
                  {translate('lmexpress.totalReceiptsTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>
                    {translate('option.currency')}
                    {Mask.toMoney(
                      lmExpress.totalReceipts
                        ? lmExpress.totalReceipts.toFixed(
                            this.state.sizeCurrency
                          )
                        : 0,
                      this.state.formatCurrency
                    )}
                  </span>
                  <span className='subtext'>
                    {filters.dtStart || filters.dtEnd
                      ? `${filters.dtStart} - ${filters.dtEnd}`
                      : ''}
                  </span>
                </div>
                <p className='text'>
                  {translate('lmexpress.totalReceiptsText')}
                </p>
              </div>
            </Col>
          </Col>
        </div>

        <Col xs={6} md={4} mdOffset={4}>
          <button
            type='button'
            onClick={getCsv}
            className='button button-primary button-full'
          >
            {translate('lmexpress.excelReport')}
          </button>
        </Col>

        {this.renderModal()}
      </div>
    )
  }
}

OlderLmExpress.propTypes = {
  translate: PropTypes.func.isRequired,
  lmExpress: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  getCsv: PropTypes.func.isRequired,
}

export default OlderLmExpress
